import Vue from 'vue'
import App from './App.vue'
import router from './router/router'
import Vant, {
  Lazyload
} from 'vant';
import store from './store'
import $ from 'jquery';
import 'signalr' // 直播通讯
import Router from 'vue-router'
import axios from './router/http';
import preview from 'vue-photo-preview';
import 'vue-photo-preview/dist/skin.css';
import directives from './directives/directives.js'
import moment from 'moment'; 
// import 'babel-polyfill';
moment.locale('EN');

// import VConsole from 'vconsole';
// if (process.env.NODE_ENV !== 'development') {
// let vConsole = new VConsole() // 初始化  
// }

import VueAwesomeSwiper from 'vue-awesome-swiper'
import VideoPlayer from 'vue-video-player';
import 'vant/lib/index.css';
import './assets/scss/ydui.css';
import './assets/js/rem.js';

import VueWechatTitle from 'vue-wechat-title';
Vue.use(VueWechatTitle);

Vue.prototype.$Bus = new Vue;


import CountryFlag from 'vue-country-flag'
Vue.component('country-flag', CountryFlag)



//  GraphQL配置
import VueApollo from 'vue-apollo'
Vue.use(VueApollo);
import ApolloClient from 'apollo-boost'
let Token = store.getters.getToken;
// const apolloClient = new ApolloClient({
//   // 服务器的地址，注意后台添加graphql这个路由
//   uri: 'http://online-api.zhanshangxiu.com/graphql',
//   headers:{
//     Authorization:"Bearer " + Token,
//   }
// })
// const apolloProvider = new VueApollo({
//   defaultClient: apolloClient
// })

const apolloClient = new ApolloClient({
  uri: 'https://tu.zhanshangxiu.com/graphql',
  headers: {
    Authorization: "Bearer " + Token,

  }
})

// apollo的请求配置
import apollo from './router/apollo';
const apolloProvider = new VueApollo({
  clients: { // 多个请求api
    api: apolloClient
  },
  defaultClient: apollo
})

// import style
import 'swiper/css/swiper.css'

// 第三方  
require('video.js/dist/video-js.css');
require('vue-video-player/src/custom-theme.css');
import './assets/scss/swiper.min.css';
import './assets/scss/index.scss';

// 引用API文件 
Vue.config.productionTip = false;
Vue.use(Vant);
Vue.use(Lazyload);
Vue.use(VideoPlayer);
Vue.use(VueAwesomeSwiper)
Vue.prototype.$http = axios;
Vue.prototype.$ = $;
Vue.prototype.$Bus = new Vue;
//解决路由跳转报错 
Vue.use(Router)
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err)
}
Vue.use(preview, {
  fullscreenEl: false
});
//解决路由跳转报错

import {
  Toast
} from 'vant';
Vue.use(Toast);
import myService from './service/service';
Vue.use(myService);

import Myapollo from './service/apollo';
Vue.use(Myapollo);

// 添加时间过滤器 引入moment.js
Vue.filter('moment', function (dataStr, pattern = 'YYYY/MM/DD HH:mm') {
  return moment(dataStr).format(pattern);
})


router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title
  }
  next();
});

let vue = new Vue({
  router,
  store,
  apolloProvider,
  render: h => h(App)
}).$mount('#app')

export default vue